import {
  ICanvasElement,
  ICanvasElementDrawArgs
} from '@/models/marketingCenter/canvas';
import { MarketingCenterColorSchemeDictionary } from '../colorScheme';

class ColoredSVGCanvasElement implements ICanvasElement {
  constructor(
    private readonly options: {
      image?: string;
      x: number;
      y: number;
      width: number;
      height: number;
      colorToBeReplaced?: string;
    }
  ) {}

  showOnPreview = true;

  async draw(context: CanvasRenderingContext2D, args: ICanvasElementDrawArgs) {
    const { image } = this.options;
    if (!args.color || !image || !context) return;

    const imageUrl = require(`../../../assets/img/${image}`);
    const color = MarketingCenterColorSchemeDictionary[args.color];
    await this.drawSVG(imageUrl, context, color.primary);
  }

  drawSVG(url: string, context: CanvasRenderingContext2D, color: string) {
    const { x, y, width, height, colorToBeReplaced = '#3E24D6' } = this.options;

    return new Promise<void>((resolve, reject) => {
      try {
        fetch(url)
          .then(response => response.text())
          .then(svgRaw => {
            const regex = new RegExp(colorToBeReplaced, 'g');

            const svgColored = svgRaw.replace(regex, color);
            const blob = new Blob([svgColored], { type: 'image/svg+xml' });
            const url = URL.createObjectURL(blob);

            const img = new Image();
            img.onerror = reject;
            img.onload = () => {
              URL.revokeObjectURL(url);
              context.drawImage(img, x, y, width, height);
              resolve();
            };
            img.src = url;
          })
          .catch(e => {
            reject(e);
          });
      } catch (e) {
        reject(e);
      }
    });
  }
}

export default ColoredSVGCanvasElement;
